import React, { useContext } from 'react'
import scrollTop from '../helpers/scrollTop'
import displayINRCurrency from '../helpers/displayCurrency'
import Context from '../context'
import addToCart from '../helpers/addToCart'
import { Link } from 'react-router-dom'

const VerticalCard = ({loading, data = []}) => {
    const loadingList = new Array(13).fill(null)
    const { fetchUserAddToCart } = useContext(Context)

    const handleAddToCart = async(e, product) => {
       await addToCart(e, product)
       fetchUserAddToCart()
    }

  return (
    <div className='grid grid-cols-[repeat(auto-fit,minmax(260px,300px))] justify-center md:justify-between gap-4 overflow-x-scroll scrollbar-none transition-all'>
    {
         loading ? (
             loadingList.map((product, index) => {
                 return(
                     <div className='w-full min-w-[260px] md:min-w-[280px] max-w-[300px] bg-white rounded-sm shadow flex flex-col' key={index}>
                         <div className='bg-slate-200 h-48 p-4 flex justify-center items-center animate-pulse'>
                         </div>
                         <div className='p-4 grid gap-3 flex-1'>
                             <div className='font-medium text-base md:text-lg text-ellipsis line-clamp-1 text-black p-1 py-2 animate-pulse rounded-full bg-slate-200'></div>
                             <p className='capitalize text-slate-500 p-1 animate-pulse rounded-full bg-slate-200 py-2'></p>
                             <div className='flex gap-3'>
                                 <p className='text-green-600 font-medium p-1 animate-pulse rounded-full bg-slate-200 w-full py-2'></p>
                                 <p className='text-slate-500 line-through p-1 animate-pulse rounded-full bg-slate-200 w-full py-2'></p>
                             </div>
                             <button className='text-sm text-white px-3 rounded-full bg-slate-200 py-2 animate-pulse mt-auto'></button>
                         </div>
                     </div>
                 )
             })
         ) : (
             data.map((product, index) => {
                 return(
                     <Link 
                         to={"/product/" + product?._id} 
                         className='w-full min-w-[260px] md:min-w-[280px] max-w-[300px] bg-white rounded-sm shadow flex flex-col hover:shadow-lg transition-shadow' 
                         onClick={scrollTop} 
                         key={product?._id}
                     >
                         <div className='bg-slate-200 h-48 p-4 flex justify-center items-center overflow-hidden'>
                             <img 
                                 src={product?.productImage[0]} 
                                 alt={product?.productName || 'Product image'} 
                                 className='object-contain h-full w-full hover:scale-110 transition-all mix-blend-multiply'
                             />
                         </div>
                         <div className='p-4 grid gap-3 flex-1'>
                             <h2 className='font-medium text-base md:text-lg text-ellipsis line-clamp-2 text-black min-h-[3rem]'>
                                 {product?.productName}
                             </h2>
                             <p className='capitalize text-slate-500 text-sm'>
                                 {product?.category}
                             </p>
                             <div className='flex gap-3 items-center'>
                                 <p className='text-green-600 font-medium text-base md:text-lg'>
                                     {displayINRCurrency(product?.sellingPrice)}
                                 </p>
                                 <p className='text-slate-500 line-through text-sm'>
                                     {displayINRCurrency(product?.price)}
                                 </p>
                             </div>
                             <button 
                                 className='text-sm bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-full transition-colors mt-auto' 
                                 onClick={(e) => handleAddToCart(e, product)}
                             >
                                 Add to Cart
                             </button>
                         </div>
                     </Link>
                 )
             })
         )
         
     }
    </div>
  )
}

export default VerticalCard